import React, { useState } from 'react';
import WebView from '../components/WebView';
import EmailTab from '../components/EmailTab';

const AnnouncementsPage = () => {
  const [activeTab, setActiveTab] = useState('notifications');

  const tabs = [
    { id: 'notifications', label: 'Notifications', icon: '🔔' },
    { id: 'email', label: 'Email', icon: '📧' }
  ];

  return (
    <div className="h-full">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">App Notifications</h1>
        <p className="text-gray-600 mt-2">
          Manage app notifications and send emails to students
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span>{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="h-full">
        {activeTab === 'notifications' && (
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden h-full">
            <WebView
              src="https://www.e-droid.net/"
              title="E-Droid Notification App"
              className="w-full h-full"
              style={{ minHeight: 'calc(100vh - 200px)' }}
              showCredentials={true}
            />
          </div>
        )}

        {activeTab === 'email' && (
          <div className="h-full">
            <EmailTab />
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnouncementsPage;